import { ThemeUIStyleObject } from "theme-ui";

export const wrapStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: ["90px", "120px"],
};

export const headerTopPaddingStyles: ThemeUIStyleObject = {
  position: "fixed",
  top: "0",
  width: "full",
  height: ["15px", "30px"],
  bg: "white",
  zIndex: "header",
};

export const containerStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "full",
  height: "full",
  zIndex: "header",
  mt: [4, 6],
  mx: "auto",
};

export const logoStyles: ThemeUIStyleObject = {
  width: ["100px"],
  height: ["36px"],
};

export const navigationWrap: ThemeUIStyleObject = {
  position: "fixed",
  right: [5, "50px"],
  top: ["auto", "50px"],
  bottom: [5, "auto"],
  zIndex: "burgerMenu",
};

export const bookTicketWrapStyles: ThemeUIStyleObject = {
  position: "fixed",
  color: "white",
  alignItems: "center",
  zIndex: 35,
  bottom: [5, "auto"],
  top: [null, "50px"],
  left: [5, "50px"],
  "> a > span:last-of-type": {
    display: ["none", "inline-block"],
  },
};

export const openingHoursStyles: ThemeUIStyleObject = {
  position: "absolute",
  minWidth: "150px",
  fontSize: "smText",
  letterSpacing: ".25em",
  mt: 6,
  mb: 0,
  top: "50%",
  transform: "translate3d(0, -50%, 0)",
  zIndex: "header",
  left: ["292.85px"],
};
